module.exports = __webpack_public_path__ + "img/IE.badfc49c.svg";